import React, { useState } from "react";
import { Box, Grid, Dialog, IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CloseIcon from "@mui/icons-material/Close";
import ReactPlayer from "react-player";

function VideoSection() {
  const [open, setOpen] = useState(false);
  const [playing, setPlaying] = useState(false);

  const handleOpenVideo = () => {
    setOpen(true);
    setPlaying(false);
  };

  const handleCloseVideo = () => {
    setOpen(false);
    setPlaying(false);
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Grid container justifyContent="center" alignItems="center">
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: 720,
            cursor: "pointer",
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 3,
          }}
          onClick={handleOpenVideo}
        >
          <Box
            component="img"
            src="/image/vedio_thamb.jpg"
            alt="Video Thumbnail"
            sx={{ width: "100%", height: "auto", display: "block" }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "rgba(0,0,0,0.6)",
              borderRadius: "50%",
              padding: 2,
            }}
          >
            <PlayArrowIcon sx={{ color: "#fff", fontSize: 60 }} />
          </Box>
        </Box>
      </Grid>

      <Dialog
        open={open}
        onClose={handleCloseVideo}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#000",
            boxShadow: "none",
            overflow: "hidden",
          },
        }}
      >
        <Box sx={{ position: "relative", paddingTop: "56.25%", width: "100%" }}>
          <ReactPlayer
            url="Actifyvideo.mp4"
            playing={playing}
            controls
            width="100%"
            height="100%"
            style={{ position: "absolute", top: 0, left: 0 }}
          />
        </Box>

        <IconButton
          onClick={handleCloseVideo}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#fff",
            backgroundColor: "rgba(179, 177, 177, 0.5)",
            "&:hover": {
              backgroundColor: "rgba(192, 185, 185, 0.7)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Dialog>
    </Box>
  );
}

export default VideoSection;
